import React, { useEffect, useState } from "react";
import { marked } from "marked";
import "./ChangelogOverlay.css";

export default function ChangelogOverlay({ onClose }) {
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch("/CHANGELOG.md")
      .then((res) => (res.ok ? res.text() : Promise.reject()))
      .then((markdown) => {
        const withResolvedImages = markdown.replace(/\]\(img\//g, "](/changelog-img/");
        setHtml(marked.parse(withResolvedImages));
      })
      .catch(() => setError(true));
  }, []);

  return (
    <div className="changelog-overlay" onClick={onClose}>
      <div className="changelog-modal" onClick={(e) => e.stopPropagation()}>
        <div className="changelog-header">
          <h2>Changelog</h2>
          <button className="changelog-close" onClick={onClose} aria-label="Schließen">×</button>
        </div>
        <div className="changelog-content">
          {error && <p>Changelog konnte nicht geladen werden.</p>}
          {!error && html && <div dangerouslySetInnerHTML={{ __html: html }} />}
        </div>
      </div>
    </div>
  );
}
